export default {
  instaTaskLayoutWrapper: {
    width: '100%',
    maxWidth: '100%',
    height: (theme) => `calc(100vh - ${theme.customValues.topBarHeight})`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '@media (max-width: 760px)': {
      height: 'auto',
      overflow: 'visible',
    },
  },
  instaTaskLayoutContentWrapper: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    borderTop: (theme) => `1px solid ${theme.palette.grays.gray200}`,
    '@media (max-width: 760px)': {
      flexDirection: 'column',
      flex: 'unset',
      minHeight: 'auto',
    },
  },
};
